import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { CustomLoader } from './Components/CustomLoader';
import Navbar from './Components/Navbar';
import MyRoutes from './MyRoutes';
import { authChecker, logout } from './redux/slice/loginSlice';
import { connectNotificationSocket } from './websocket/notificationSocket';
import { fetchNotifications } from './redux/slice/NotificationSlice';

const App = () => {
  const { isAuthChecking, isSessionExpired, isLoading, isLoggedIn } = useSelector((state) => state.login)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(authChecker())
  }, [])

  const socketStarted = useRef(false);
  
  useEffect(() => {
    // only call if loggedIn
    if (isLoggedIn) {
      socketStarted.current = true;
      connectNotificationSocket();
      dispatch(fetchNotifications());
    }
  }, [isLoggedIn]);


  useEffect(() => {
    if (!isAuthChecking && isSessionExpired) {
      dispatch(logout());
      alert("Session Expired. Please log in.");
    }
  }, [isSessionExpired])

  if (isAuthChecking || isLoading) {
    return (
      <div style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f7fa"
      }}>
        <CustomLoader />
        <p style={{
          marginTop: "20px",
          fontSize: "18px",
          fontWeight: "500",
          color: "#1672DE",
          letterSpacing: "0.5px"
        }}>Loading, Please Wait</p>
      </div>
    )
  }

  return (
    <div style={{ position: 'relative' }}>
      <Navbar />
      <MyRoutes />
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
      />
    </div>
  );
};

export default App;
